import { render, staticRenderFns } from "./Assignoperators.vue?vue&type=template&id=70ecdada&scoped=true&"
import script from "./Assignoperators.vue?vue&type=script&lang=js&"
export * from "./Assignoperators.vue?vue&type=script&lang=js&"
import style0 from "./Assignoperators.vue?vue&type=style&index=0&id=70ecdada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecdada",
  null
  
)

export default component.exports